import {
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    LinearScale,
    Tooltip,
} from "chart.js";

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip);

const buildCurrencyFormatter = (currency) =>
    new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
    });

const buildNumberFormatter = () =>
    new Intl.NumberFormat(undefined, {
        maximumFractionDigits: 0,
    });

export const registerRevenueByChannelChart = (Alpine) => {
    Alpine.data("revenueByChannelChart", ({ labels = [], values = [], currency }) => ({
        chart: null,
        formatter: buildCurrencyFormatter(currency || "USD"),
        numberFormatter: buildNumberFormatter(),
        init() {
            if (!this.$refs.canvas || labels.length === 0) {
                return;
            }

            this.chart = new Chart(this.$refs.canvas, {
                type: "bar",
                data: {
                    labels,
                    datasets: [
                        {
                            data: values,
                            backgroundColor: "rgba(37, 99, 235, 0.7)",
                            borderRadius: 8,
                            barThickness: 16,
                            maxBarThickness: 20,
                            categoryPercentage: 1,
                            barPercentage: 1,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    indexAxis: "y",
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    const raw = Number(context.raw ?? 0);
                                    return this.numberFormatter.format(raw);
                                },
                            },
                        },
                    },
                    scales: {
                        y: {
                            grid: { display: false },
                            ticks: {
                                autoSkip: false,
                            },
                        },
                        x: {
                            ticks: {
                                callback: (value) => this.numberFormatter.format(Number(value)),
                            },
                            grid: {
                                color: "rgba(148, 163, 184, 0.2)",
                            },
                        },
                    },
                },
            });
        },
        destroy() {
            if (this.chart) {
                this.chart.destroy();
                this.chart = null;
            }
        },
    }));
};
